module.exports = __webpack_public_path__ + "img/Sfu.fb598309.png";